export const visitText = {
  UNAVAILABLE: 'timezone unavailable',
}
